import axios, { AxiosResponse, InternalAxiosRequestConfig } from 'axios';
import Cookies from 'js-cookie';
import { env } from 'env';

export const API_URL = env.REACT_APP_API_URL;

// Cross-system correlation id for the observability hub (SOLUTION-DESIGN
// §9.1). Set once at startup by MytaverseProvider; attached to every
// outgoing request below so it appears in spatial-manager logs and Sentry
// breadcrumbs alongside the same id stamped on the WS payload and Sentry
// scope tag.
let mytaCorrelationId: string | null = null;

export const setMytaCorrelationId = (id: string): void => {
  mytaCorrelationId = id;
};

const $api = axios.create({
  baseURL: API_URL,
});

$api.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  config.headers.set('Authorization', `${Cookies.get('token')}`);

  //Todo: Check witn new axios
  if (mytaCorrelationId) {
    (config.headers as any)['X-Mytaverse-Correlation-Id'] =
      mytaCorrelationId;
  }

  if (config.url?.includes('/ping')) {
    const requestStartTime = Date.now();

    const metadata = {
      requestStartTime,
    };

    config.data = config.data ? { ...config.data, metadata } : { metadata };
  }
  return config;
});

$api.interceptors.response.use((response: AxiosResponse) => {
  if (response.config.url?.includes('/ping')) {
    if (response.config.data) {
      const { metadata } = JSON.parse(response.config.data);
      if (metadata) {
        const duration = Date.now() - metadata.requestStartTime;

        const data = JSON.parse(response.config.data);
        response.data = { ...data, requestDuration: duration };
      }
    }
  }

  return response;
});

export default $api;
